import { createSlice } from "@reduxjs/toolkit";

const snackSlice = createSlice({
  name: 'snack',
  initialState: { message: null, severity: null, open: false },
  reducers: {
    successSnack: (state, action) => {
      const { message } = action.payload;
      state.message = message;
      state.severity = "success";
      state.open = true;
    },
    warningSnack: (state, action) => {
      const { message } = action.payload;
      state.message = message;
      state.severity = "warning";
      state.open = true;
    },
    errorSnack: (state, action) => {
      const { message } = action.payload;
      state.message = message;
      state.severity = "error";
      state.open = true;
    },
    infoSnack: (state, action) => {
      const { message } = action.payload;
      state.message = message;
      state.severity = "info";
      state.open = true;
    },
    clearSnack: (state) => {
      state.open = false;
    }
  },
});

export const { successSnack, warningSnack, errorSnack, infoSnack, clearSnack } = snackSlice.actions;

export default snackSlice.reducer;

export const selectSnack = state => state.snack;
